import { status } from "skin/event/status";


const screenIOS = (obj, form, story, data, d, action) => {
    story.current.info = 'ios';
    return status.action;
}

export default screenIOS;